module.exports = __webpack_public_path__ + "img/cover_photo.43f71243.jpg";